import * as React from 'react'
import { I18n } from "react-redux-i18n";

import { Button } from '@common/components/Button';
import { getTestAttributes } from '@common/utils/tests';
import { FolderTemplateOption } from '@common/dto/folder-settings';

import './template-options.styles.scss';

type TemplateOptionsProps = {
  selectedTemplateOptions?: Partial<FolderTemplateOption>;
  onChange: (value: Partial<FolderTemplateOption>) => void;
  onOpenFormatModal: () => void;
};

type TemplateOptionsCheckboxDataset = { fieldKey: string; };

export const TemplateOptions = ({ selectedTemplateOptions, onChange, onOpenFormatModal }: TemplateOptionsProps) => {

  const templateOptions = React.useMemo(() => {
    const optionsAsObject: Record<keyof FolderTemplateOption, { label: string; labelId: string; inputId: string }> = {
      tempIds: {
        label: I18n.t('Individual Datasheet'),
        labelId: 'cbx-folder-settings-ids-label',
        inputId: 'cbx-folder-settings-ids-input',
      },
      tempPds: {
        label: I18n.t('Pedigree Datasheet'),
        labelId: 'cbx-folder-settings-pds-label',
        inputId: 'cbx-folder-settings-pds-input',
      },
      tempSubtext: {
        label: I18n.t('Icon Subtext'),
        labelId: 'cbx-folder-settings-sub-text-label',
        inputId: 'cbx-folder-settings-sub-text-input',
      },
      tempSymbols: {
        label: I18n.t('Icon Symbols'),
        labelId: 'cbx-folder-settings-symbols-label',
        inputId: 'cbx-folder-settings-symbols-input',
      },
      tempAddText: {
        label: I18n.t('Pedigree Added Text'),
        labelId: 'cbx-folder-settings-added-text-label',
        inputId: 'cbx-folder-settings-added-text-input',
      },
      tempSmartDrawDims: {
        label: I18n.t('SmartDraw Dimensions'),
        labelId: 'cbx-folder-settings-smart-draw-label',
        inputId: 'cbx-folder-settings-smart-draw-input',
      },
      tempPedProperties: {
        label: I18n.t('Pedigree Properties'),
        labelId: 'cbx-folder-settings-ped-props-label',
        inputId: 'cbx-folder-settings-ped-props-input',
      },
      tempPedDropFields: {
        label: I18n.t('Pedigree Fields '),
        labelId: 'cbx-folder-settings-drop-fields-label',
        inputId: 'cbx-folder-settings-drop-fields-input',
      },
      tempHeader: {
        label: I18n.t('Smart Header'),
        labelId: 'cbx-folder-settings-smart-header-label',
        inputId: 'cbx-folder-settings-smart-header-input',
      },
      tempFooter: {
        label: I18n.t('Smart Footer'),
        labelId: 'cbx-folder-settings-smart-footer-label',
        inputId: 'cbx-folder-settings-smart-footer-input',
      },
    };

    return Object.keys(optionsAsObject).map((key) => {
      const option = optionsAsObject[key as keyof FolderTemplateOption];

      return {
        id: {
          label: option.labelId,
          input: option.inputId,
        },
        key: key as keyof FolderTemplateOption,
        title: option.label,
      };
    });

  }, []);

  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { dataset, checked } = e.target;
    const { fieldKey } = dataset as unknown as TemplateOptionsCheckboxDataset;

    onChange({ ...selectedTemplateOptions, [fieldKey]: checked });
  }, [onChange, selectedTemplateOptions]);



  return (
    <div className="FolderManagement__template-options">
      <h5
        className="FolderManagement__template-options__title"
        {...getTestAttributes({ id: 'lbl-folder-settings-temp-options' })}
      >
        {I18n.t('Template Options')}
      </h5>
      <ul className="FolderManagement__template-options__list">
        {templateOptions.map((option) => {
          return (
            <li className="FolderManagement__template-options__list__item" key={option.key}>
              <input
                type="checkbox"
                className="FolderManagement__template-options__checkbox"
                checked={Boolean(selectedTemplateOptions?.[option.key])}
                data-field-key={option.key}
                onChange={handleChange}
                {...getTestAttributes({ id: option.id.input })}
              />
              <label
                className="FolderManagement__template-options__checkbox__label"
                id={option.id.label}
                htmlFor={getTestAttributes({ id: option.id.input }).id}
              >
                {option.title}
              </label>
            </li>
          )
        })}
      </ul>
      <Button
        {...getTestAttributes({ id: 'btn-folder-settings-formats' })}
        onClick={onOpenFormatModal}
      >
        {I18n.t('Formats')}
      </Button>
    </div>
  )
};